import React from "react";
import "./OurJourney.css";
import parse from "html-react-parser";
import { Container } from "react-bootstrap";

const OurJourney = ({ about_us }) => {
  return (
    <section className="our-journey-section">
      <Container>
        <div className="about-wrapper">
          <div className="about-heading">
            <span className="about-subtitle">Our Story</span>
            <h2 className="about-title">About Us</h2>
            <div className="title-line"></div>
          </div>

          <div className="about-content-card">
            <div className="about-text">
              {typeof about_us?.content === "string"
                ? parse(about_us.content)
                : "No content available."}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default OurJourney;
